/* eslint-disable import/no-anonymous-default-export */
export default {
    backend_url: false
};
  